import { cn } from '@tripleten/cn';

export const cnLoginResetPassword = cn('login-reset-password');
